import axios from "@/config/axios";

const initialState = () => {
  return {
    password: [],
  };
};

const state = initialState();

const getters = {
  getPasswordUpdateStatus: (state) => state.password,
};

const mutations = {
  setPassword(state, password) {
    state.password = password;
  },
  reset: (state) => {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const actions = {
  updatePassword: async ({ commit, dispatch }, params) => {
    try {
      await dispatch("errors/clear", [], { root: true });
      commit("setPassword", null);
      const response = await axios.patch("/password/update", params);

      commit("setPassword", response.data);
    } catch (error) {
      if (error.response) {
        dispatch("errors/errorResponse", error.response, { root: true });
      }
    }
  },
  errorResponse: async (context, errorResponse) => {
    let errorStatusCode = errorResponse?.status;
    let errorData = {};

    switch (errorStatusCode) {
      case 422:
        var errors = errorResponse.data.errors;
        errors.details.forEach((detail) => {
          if (!errorData[detail.key]) {
            errorData[detail.key] = detail.message;
          }
        });
        break;
      case 401:
      case 403:
        errorData["critical_error"] = errorResponse.data.message;
        break;

      default:
        errorData["critical_error"] = errorResponse.data.message;
        break;
    }
    return errorData;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
